module.exports = require("@pb/kit-component-loading");